export default "__VITE_ASSET__656570ba__"